import { InjectionToken } from '@angular/core';

export const URL_BASE_PATH = new InjectionToken<string>('basePath');
export const CURRENT_TENANT = new InjectionToken<string>('currentTenant');
export const THEME = new InjectionToken<string>('theme');
